import PropTypes from 'prop-types';
import Coffee from '../../assets/svg/coffee.svg';
import useAnalyticsEvent from '../../hooks/useAnalyticsEvent';

const CoffeeLink = ({ placement }) => {
  const emitEvent = useAnalyticsEvent();

  // Return null if window is not available, like during a build
  if (typeof window === 'undefined') {
    return null;
  }

  const pageUrl = window?.location?.pathname;

  const onClick = () => {
    emitEvent({
      action: `coffeeLinkClick-${placement}`,
      category: 'coffeeLink',
      label: pageUrl,
    });
  };

  return (
    <a
      href="https://www.buymeacoffee.com/letsbuildui"
      className="coffee post-action-link"
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      <Coffee />
      <span>Buy Me a Coffee</span>
    </a>
  );
};

CoffeeLink.propTypes = {
  placement: PropTypes.string.isRequired,
};

export default CoffeeLink;
